<template>
  <div id="star-container">
      <template v-if="!success">
        <div id="star-header">
          <h3 class="title">
            <strong>{{ box.title }}</strong>
            <div v-if="lang == 'en'">
              1 item of your choice + 3 other surprise items
            </div>
            <div v-else>1 capo a scelta + altri 3 a sorpresa</div>
          </h3>
          <p class="instruction" v-if="!loading && lang == 'en'">
            Click on the item to see details
          </p>
          <p class="instruction" v-if="!loading && lang != 'en'">
            Clicca sul capo per vedere i dettagli
          </p>
        </div>
        <template v-if="!loading">
          <div v-if="stars && stars.length > 0" class="stars">
            <a
              class="star"
              v-for="star in stars"
              :key="star.id"
              data-aos="zoom-in"
              @click="showDetail($event, star)"
            >
              <img
                v-if="star.images && star.images.front"
                :src="star.images.front"
              />
              <h4>{{ star.title }}</h4>
            </a>
          </div>
          <div v-else>
            <p v-if="lang == 'en'" class="notfound">
              Sorry, no star garment matches the selected mood.
              <button @click.prevent="reset()">Try again</button>
            </p>
            <p v-else class="notfound">
              Ci dispiace, nessun capo star corrisponde al mood selezionato.
              <button @click.prevent="reset()">Riprova</button>
            </p>
          </div>
          <div class="mood-buttons">
            <button
              v-if="lang == 'en'"
              @click.prevent="reset()"
              class="btn btn-dark-outline"
            >
              Back
            </button>
            <button
              v-else
              @click.prevent="reset()"
              class="btn btn-dark-outline"
            >
              Back
            </button>
          </div>
        </template>
        <template v-else>
          <Preloader />
        </template>
      </template>

      <template v-else>
        <div id="success">
          <Preloader />
        </div>
      </template>


      <div id="starDetail" v-if="detail">
      <template v-if="!addtocartloading">
        <div class="images">
          <div class="slides">
          <img
            v-if="detail.images_lg && detail.images_lg.front"
            :src="detail.images_lg.front"
            id="slide-1"
          />
          <img
            v-if="detail.images_lg && detail.images_lg.back"
            :src="detail.images_lg.back"
            id="slide-2"
          />
          <img
            v-if="detail.images_lg && detail.images_lg.indossato"
            :src="detail.images_lg.indossato"
            id="slide-3"
          />
        </div>

        </div>

        <div class="content">
          <h2>{{ detail.title }}</h2>
          <div v-if="detail.size !== ''">{{ detail.size }}</div>
          <div v-else>Taglia unica</div>
          <p>{{ detail.description }}</p>
          <button
            id="chiudi-detail"
            @click="detail = null"
            class="btn btn-outline"
          >
            <svg class="icon">
              <use xlink:href="#icon-close" />
            </svg>
          </button>
          <div class="cta">
            <button
              @click="salvaCarrello(detail.id)"
              class="btn btn-lg btn-primary"
            >
              {{ btn }}
            </button>
          </div>
        </div>
      </template>
      <template v-else>
        <div id="saving">{{ saving }}</div>
      </template>
    </div>

    </div>
    
    </template>
<script>
import axios from "axios";
import Preloader from "@/components/Preloader.vue";

export default {
  data() {
    return {
      loading: false,
      success: false,
      addtocartloading: false,
      detail: null,
      stars: [],
      selectedStar: "",
      page: 1,

      btn: "",
      saving: "",
    };
  },

  components: {
    Preloader,
  },

  props: {
    lang: String,
  },

  computed: {
    size: function() {
      return localStorage.getItem("menaboh_size");
    },
    box: function() {
      return JSON.parse(localStorage.getItem("menaboh_box"));
    },
    keywords: function() {
      const keywords = JSON.parse(localStorage.getItem("menaboh_keywords"));

      //const res = key.map(o => o[1]);
      const k = [];
      keywords.forEach((element) =>
        element.forEach((e) => {
          if (!k.includes(e["slug"])) {
            k.push(e["slug"]);
          }
        })
      );

      return k;
    },
    cartUrl: function() {
      return window["wcApiSettings"]._cart;
    },
    checkoutUrl: function() {
      return window["wcApiSettings"]._checkout;
    },
  },
  methods: {
    fetchStars() {
      if (this.lang == "en") {
        this.btn = "Confirm";
        this.saving = "Elaborating...";
      } else {
        this.btn = "Scegli";
        this.saving = "Ordine in elaborazione...";
      }

      this.loading = true;

      const params = {
        size: this.size,
        box: this.box.id,
        keywords: this.keywords,
        page: this.page,
      };

      axios
        .get(window["wpApiSettings"].root + "menaboh/v1/star", { params })
        .then(
          (response) => (
            console.log(response.data),
            (this.stars = response.data),
            (this.loading = false)
          )
        );
    },

    generate_token: function(length) {
      var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      return b.join("");
    },

    showDetail: function(e, star) {
      this.detail = star;
    },

    salvaCarrello: function(capo_star_id) {
      this.addtocartloading = true;
      const box = JSON.parse(localStorage.getItem("menaboh_box"));
      const shop_product = box.shop_product;
      const images = JSON.parse(localStorage.getItem("menaboh_selected")).map(
        (a) => a.id
      );
      const key = this.generate_token(8);
      const params = {
        cart_key: key,
        item_box: box.id,
        item_star: capo_star_id,
        item_size: localStorage.getItem("menaboh_size"),
        item_images: images,
        status: "created",
      };
      axios
        .post(window["wpApiSettings"].root + "menaboh/v1/carts", params)
        .then(
          (response) => (
            (this.success = response.data),
            (window.location.href =
              this.cartUrl +
              "?add-to-cart=" +
              shop_product.id +
              "&cart_key=" +
              key),
            localStorage.setItem("menaboh_cart", key),
            localStorage.removeItem("menaboh_box"),
            localStorage.removeItem("menaboh_size"),
            localStorage.removeItem("menaboh_selected"),
            localStorage.removeItem("menaboh_keywords"),
            localStorage.removeItem("menaboh_step")
          )
        );
    },

    reset() {
      localStorage.removeItem("menaboh_size");
      this.$store.commit("goToStep", 2);
    },
  },

  mounted() {
    this.fetchStars();
  },
};
</script>
<style lang="scss">
#star-container {
  margin-top: 70px;
  padding: 1rem 1rem 1rem 1rem;
  transition: all 0.4s ease-in-out;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

#star-header {
  text-align: center;
}

.title {
  margin: 0;
}
.instruction {
  margin: 0 0 1rem 0;
}

.notfound {
  max-width: 300px;
  text-align: center;
  display: block;
  margin: 2rem auto;
}

#starDetail {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2rem 2rem 100px 2rem;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-touch-action: auto;
  touch-action: auto;

  .images {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    width: 100%;
    padding: 1rem;

    h2 {
      font-size: 1.5rem;
    }

    .cta {
      position: fixed;
      background: linear-gradient(
        180deg,
        rgba(#fff, 0) 16%,
        rgba(#fff, 1) 75%
      );
      z-index: 999;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      padding: 1rem;

    }
  }

  @media screen and (min-width: 768px) {
    flex-direction: column;

    .images {
      width: 50%;
    }
    .content {
      width: 50%;
    }
  }
  #chiudi-detail {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 999;
    svg {
      width: 30px;
      height: 30px;
    }
  }
}

.stars {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
  @media screen and (min-width: 320px) {
      flex-direction: row;
  }


  .star {
    text-align: center;
    font-size: 14px;
    width: calc(100% - 10px);
    background: white;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    padding: 10px;
    border: 1px solid gainsboro;

    img {
      margin-top: auto;
      margin-bottom: auto;
    }

    h4 {
      font-size: 1rem;
      margin-top: auto;
    }

    @media screen and (min-width: 320px) {
      width: calc(50% - 10px);
    }

    @media screen and (min-width: 768px) {
      width: calc(33.3333% - 10px);
    }

    @media screen and (min-width: 960px) {
      width: calc(25% - 10px);
    }
  }
}

#success {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  color:#FFF;
}

#saving {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}


.slider {
  width: 300px;
  text-align: center;
  overflow: hidden;

.slides {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
.slides::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.slides::-webkit-scrollbar-thumb {
  background: black;
  border-radius: 10px;
}
.slides::-webkit-scrollbar-track {
  background: transparent;
}
.slides > img {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 95%;
  margin-right: 0;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s;
  position: relative;
}

.slider > a {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  background: white;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 0 0.5rem 0;
  position: relative;
}
.slider > a:active {
  top: 1px;
}
.slider > a:focus {
  background: #000;
}
}

</style>